function toggle_light() {
  const prev_dark_mode: boolean = $("html").data("dark-mode") ?? false;
  if (prev_dark_mode) {
    $("html").removeAttr("data-theme"); // back to light mode
  } else {
    $("html").attr("data-theme", "dark"); // enter dark mode
  }
  $("html").data("dark-mode", !prev_dark_mode);
  window.localStorage.setItem(
    "is-dark-mode",
    $("html").data("dark-mode").toString()
  );
}

export function initialize_light() {
  let x: string = window.localStorage.getItem("is-dark-mode");
  if (x === null) {
    x = "false";
  }
  const is_dark_mode: boolean = x == "true";

  $("html").data("dark-mode", false);
  if (is_dark_mode) {
    toggle_light();
  }
  $("#DarkSwitch").click(function () {
    toggle_light();
    return false;
  });
}
